import { render } from "./DoMore.vue?vue&type=template&id=a67c1efc"
import script from "./DoMore.vue?vue&type=script&lang=js"
export * from "./DoMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__